import React from 'react';
import { getGeocode } from 'use-places-autocomplete';
import { getLocationFromMap, TakeOffMarker } from '@src/core/controllers';
import { useDispatch, useSelector } from 'react-redux';
import { useGetUserDataQuery } from '@src/core/features';
import { selectReadOnlyTakeOff, selectTakeOffLocation, setTakeOffLocation } from '@src/features/order/pages/upsert-order-page/redux';
import { TakeOffPointProps } from './types';

const TakeOffPoint: React.FC<TakeOffPointProps> = () => {
  const dispatch = useDispatch();
  const { data } = useGetUserDataQuery();
  const location = useSelector(selectTakeOffLocation);
  const readOnly = useSelector(selectReadOnlyTakeOff);

  const onDragEnd = async (e: google.maps.MapMouseEvent) => {
    const location = await getLocationFromMap(e);
    
    if (!location) return;
  
    dispatch(setTakeOffLocation(location));
  };

  React.useEffect(() => {

    const address = data?.hub?.name;
    const lat = Number(data?.hub?.latitude);
    const lng = Number(data?.hub?.longitude);

    if (!address || !lat || !lng) return;

    dispatch(setTakeOffLocation({
      address,
      latitude: lat,
      longitude: lng,
    }));

  }, [data?.hub]);



  const lat = Number(location?.latitude);
  const lng = Number(location?.longitude);

  if (isNaN(lat) || isNaN(lng)) return null;

  return (
    <TakeOffMarker 
      draggable={!readOnly} 
      position={{ lat, lng }} 
      onDragEnd={onDragEnd} />
  );
};

export default TakeOffPoint;